document.addEventListener('DOMContentLoaded', function() {
  function MorphDropdown(element) {
    this.element = element;
    this.mainNavigation = element.querySelector('.main-nav');
    this.mainNavigationItems = element.querySelectorAll('.main-nav .has-dropdown');
    this.dropdownList = element.querySelector('.dropdown-list');
    this.dropdownWrappers = this.dropdownList ? this.dropdownList.querySelectorAll('.dropdown') : [];
    this.dropdownItems = this.dropdownList ? this.dropdownList.querySelectorAll('.content') : [];
    this.dropdownBg = this.dropdownList ? this.dropdownList.querySelector('.bg-layer') : null;
    this.mq = this.checkMq();
    this.bindEvents();
  }

  MorphDropdown.prototype.checkMq = function() {
    return window.getComputedStyle(this.element, '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "").split(', ');
  };

  MorphDropdown.prototype.bindEvents = function() {
    var self = this;

    this.mainNavigationItems.forEach(function(item) {
      item.addEventListener('mouseenter', function() {
        self.showDropdown(item);
      });
      item.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (self.mainNavigation.querySelector('.has-dropdown:hover') === null &&
              self.dropdownList && !self.dropdownList.matches(':hover')) {
            self.hideDropdown();
          }
        }, 50);
      });
      item.addEventListener('touchstart', function(event) {
        var contentId = item.dataset.content;
        var selectedDropdown = self.dropdownList ? self.dropdownList.querySelector('#' + contentId) : null;
        if (!self.element.classList.contains('is-dropdown-visible') || !selectedDropdown || !selectedDropdown.classList.contains('active')) {
          event.preventDefault();
          self.showDropdown(item);
        }
      });
    });

    if (this.dropdownList) {
      this.dropdownList.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (self.mainNavigation.querySelector('.has-dropdown:hover') === null &&
              self.dropdownList && !self.dropdownList.matches(':hover')) {
            self.hideDropdown();
          }
        }, 50);
      });
    }

    this.element.addEventListener('click', function(event) {
      if (!event.target.closest('.nav-trigger')) return;
      event.preventDefault();
      self.element.classList.toggle('nav-open');
      var searchForm = document.querySelector('.layout-search-form');
      if (searchForm) searchForm.classList.remove('active');
    });
  };

  MorphDropdown.prototype.showDropdown = function(item) {
    this.mq = this.checkMq();
    if (this.mq == 'desktop') {
      var self = this;
      var contentId = item.dataset.content;
      var selectedDropdown = this.dropdownList ? this.dropdownList.querySelector('#' + contentId) : null;
      if (!selectedDropdown) return;
      var selectedDropdownHeight = selectedDropdown.offsetHeight;
      var contentEl = selectedDropdown.querySelector('.content');
      var selectedDropdownWidth = contentEl ? contentEl.offsetWidth : 0;
      var itemRect = item.getBoundingClientRect();
      var selectedDropdownLeft = itemRect.left + item.offsetWidth / 2 - selectedDropdownWidth / 2;
      console.log("item.offset:" + itemRect.left);

      this.updateDropdown(selectedDropdown, selectedDropdownHeight, selectedDropdownWidth, Math.round(selectedDropdownLeft));

      this.element.querySelectorAll('.active').forEach(function(el) { el.classList.remove('active'); });
      selectedDropdown.classList.add('active');
      selectedDropdown.classList.remove('move-left', 'move-right');

      var prev = selectedDropdown.previousElementSibling;
      while (prev) { prev.classList.add('move-left'); prev = prev.previousElementSibling; }
      var next = selectedDropdown.nextElementSibling;
      while (next) { next.classList.add('move-right'); next = next.nextElementSibling; }

      item.classList.add('active');

      if (!this.element.classList.contains('is-dropdown-visible')) {
        setTimeout(function() {
          self.element.classList.add('is-dropdown-visible');
        }, 10);
      }
    }
  };

  MorphDropdown.prototype.updateDropdown = function(dropdownItem, height, width, left) {
    if (this.dropdownList) {
      this.dropdownList.style.transform = 'translateX(' + left + 'px)';
      this.dropdownList.style.width = width + 'px';
      this.dropdownList.style.height = height + 'px';
    }
    if (this.dropdownBg) {
      this.dropdownBg.style.transform = 'scaleX(' + width + ') scaleY(' + height + ')';
    }
  };

  MorphDropdown.prototype.hideDropdown = function() {
    this.mq = this.checkMq();
    if (this.mq == 'desktop') {
      this.element.classList.remove('is-dropdown-visible');
      this.element.querySelectorAll('.active').forEach(function(el) { el.classList.remove('active'); });
      this.element.querySelectorAll('.move-left').forEach(function(el) { el.classList.remove('move-left'); });
      this.element.querySelectorAll('.move-right').forEach(function(el) { el.classList.remove('move-right'); });
    }
  };

  MorphDropdown.prototype.resetDropdown = function() {
    this.mq = this.checkMq();
    if (this.mq == 'mobile') {
      if (this.dropdownList) this.dropdownList.removeAttribute('style');
    }
  };

  var morphDropdowns = [];
  var dropdownEls = document.querySelectorAll('.cd-morph-dropdown');
  if (dropdownEls.length > 0) {
    dropdownEls.forEach(function(el) {
      morphDropdowns.push(new MorphDropdown(el));
    });

    var resizing = false;
    updateDropdownPosition();

    window.addEventListener('resize', function() {
      if (!resizing) {
        resizing = true;
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(updateDropdownPosition);
        } else {
          setTimeout(updateDropdownPosition, 300);
        }
      }
    });
  }

  function updateDropdownPosition() {
    morphDropdowns.forEach(function(el) {
      el.resetDropdown();
    });
    resizing = false;
  }
});
